module.exports = __webpack_public_path__ + "assets/img/lector-3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-3.png
// module id = 1960
// module chunks = 0